import { TableHoverActions, useModal, withModalConditionalRender } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useSegment } from '../../../../../../hooks'
import { VatDeclarationsRegisterPeriodPaymentModal } from '../../../VatDeclarationsRegisterPeriodPaymentModal'
import { VatDeclarationsTableStaticActionType } from '../../enums/vatDeclarationsStaticActionType'

const RegisterVatDeclarationPaymentModal = withModalConditionalRender(VatDeclarationsRegisterPeriodPaymentModal)

const getRegisterVatDeclarationPaymentModalId = (id: string) => `${id}-register-vat-declaration-payment-modal`

interface VatDeclarationsTableStaticActionsProps {
  vatDeclarationId: string
}

export const VatDeclarationTableHoverActions = ({
  vatDeclarationId,
}: VatDeclarationsTableStaticActionsProps): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()

  const registerVatDeclarationPaymentModalId = getRegisterVatDeclarationPaymentModalId(vatDeclarationId)
  const { open: openRegisterPaymentModal } = useModal(registerVatDeclarationPaymentModalId)

  const handleRegisterPaymentActionClick = useCallback(() => {
    track('xxx - bookkeeping - QuickAction Clicked', {
      list: 'Vat Declarations',
      button: VatDeclarationsTableStaticActionType.RegisterPayment,
    })
    openRegisterPaymentModal()
  }, [openRegisterPaymentModal, track])

  return (
    <>
      <TableHoverActions>
        <TableHoverActions.Item
          icon="handCoins"
          label={t('bills.table.static_actions.register_payment')}
          onClick={handleRegisterPaymentActionClick}
        />
      </TableHoverActions>
      <RegisterVatDeclarationPaymentModal
        id={registerVatDeclarationPaymentModalId}
        vatDeclarationId={vatDeclarationId}
      />
    </>
  )
}
